// extracted by mini-css-extract-plugin
module.exports = {"root":"vQQ+PkF0","dark":"_2o32R4n8","heading":"MaF5k9pg","description":"np6pE+wU","content":"_4yCKoOHK"};